import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function LegalLayout({ title, effective, children }) {
  const navigate = useNavigate();
  return (
    <div className="care-scope min-h-screen w-full flex justify-center bg-black">
      <div className="relative w-full max-w-[430px] min-h-screen bg-[#111111] flex flex-col">
        <header className="sticky top-0 z-40 bg-[#111111] border-b border-[#333333] px-4 py-4 flex items-center gap-3">
          <button
            data-testid="legal-back-button"
            aria-label="Go back"
            onClick={() => navigate(-1)}
            className="min-h-[44px] min-w-[44px] -ml-2 flex items-center justify-center rounded-xl text-[#F8FAFC] hover:bg-white/5 transition-colors"
          >
            <ChevronLeft size={26} />
          </button>
          <h1 className="font-head text-xl font-bold text-[#F8FAFC] truncate">{title}</h1>
        </header>
        <main className="flex-1 px-6 py-6">
          {effective && <p className="text-xs text-[#666666] mb-4">Effective {effective}</p>}
          <div className="legal-body space-y-4 text-sm text-[#A1A1AA] leading-relaxed">{children}</div>
          <p className="mt-10 pt-6 border-t border-[#333333] text-xs text-[#666666]">
            Pocket Docta Ltd · Company No. 17356731 · 71 Alderton Road, London CR0 6HL, United Kingdom ·
            info@pocketdocta.com
          </p>
        </main>
      </div>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-head text-lg font-bold text-[#F8FAFC] pt-3">{children}</h2>;
}

export function P({ children }) {
  return <p>{children}</p>;
}

export function UL({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}
